export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('Vue App Error:', error, info, instance)
  }
  nuxtApp.hook('app:error', (error) => {
    console.error('Nuxt App Error Hook:', error)
  })
})
